module.exports = __webpack_public_path__ + "img/merchant-home-zzewm.c6f440ee.png";